export const TAX_REGIMES = {
  COORPORATE: {
    key: 'COORPORATE',
    text: 'Persona Moral',
    value: 'corporate',
  },
  INDIVIDUAL: {
    key: 'INDIVIDUAL',
    text: 'Persona Física',
    value: 'individual',
  },
};
